/* eslint-disable no-empty */
/* eslint-disable max-statements */

import { SET_THEME } from '../types/types';

export const setTheme = (dark: boolean) => (dispatch: any) => {
	dispatch({ type: SET_THEME, dark: !dark });
};
